export const CATALOG_SESSION_KEY = 'CATALOG_SESSION';
export const CATALOG_DEFAULT_SORT = 'price,asc';
export const CATALOG_DEFAULT_SIZE = 8;
export const CATALOG_DEFAULT_PAGE = 1;
